<script setup>
const { locale } = useI18n()
</script>

<template>
  <div class="flex flex-col items-center w-[244px] justify-center p-4 -my-3 bg-pageSecondary rounded-xl">
    <div class="w-[212px] h-[212px] rounded-xl bg-pageTertiary flex items-center justify-center p-2.5">
      <CommonXQRCode has-logo :url="`${spotOrigin}/${locale}/download`" class="w-[192px] h-[192px]" />
    </div>
    <span class="mt-2 font-medium text-textPrimary">{{ $t('下载APP') }}</span>
  </div>
</template>
